/**
 * Assortment Request Store
 * Session-level store for tracking items selected for assortment opening requests.
 * Survives navigation but resets on page refresh (no Firestore persistence).
 */
import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useAssortmentRequestStore = defineStore('assortmentRequest', () => {
  // State — plain object keyed by makat for O(1) lookup
  const selectedMakats = ref({})
  // Snapshot of target client info — survives navigation after agent catalog unmounts
  const clientInfo = ref(null)

  // Getters
  const count = computed(() => Object.keys(selectedMakats.value).length)
  const isEmpty = computed(() => count.value === 0)
  const selectedList = computed(() => Object.keys(selectedMakats.value))

  // Actions
  function setClientInfo(client) {
    if (client && !clientInfo.value) {
      clientInfo.value = {
        name: client.name || client.CUSTDES || '',
        makat: client.makat || client.CUSTNAME || '',
      }
    }
  }

  function toggle(makat) {
    const current = selectedMakats.value
    if (current[makat]) {
      const { [makat]: _, ...rest } = current
      selectedMakats.value = rest
    } else {
      selectedMakats.value = { ...current, [makat]: true }
    }
  }

  function has(makat) {
    return !!selectedMakats.value[makat]
  }

  function remove(makat) {
    if (selectedMakats.value[makat]) {
      const { [makat]: _, ...rest } = selectedMakats.value
      selectedMakats.value = rest
    }
  }

  function clear() {
    selectedMakats.value = {}
    clientInfo.value = null
  }

  return {
    selectedMakats,
    clientInfo,
    count,
    isEmpty,
    selectedList,
    setClientInfo,
    toggle,
    has,
    remove,
    clear,
  }
})
